import { makeQuery, makeQueryWithVars } from '../utils';

import { getDemandContracts } from './demand-contracts';
import {
  getExpectedEarningsShares,
  getExpectedEarningsSharesBySubAccountUuid,
} from './expected-earnings-shares';
import { getDemandSubAccounts } from './sub-accounts';

export { createExpectedEarningsShare } from './expected-earnings-shares';

export const financeQueries = {
  demandContracts: makeQueryWithVars({
    queryFn: getDemandContracts,
    queryKey: 'demandContracts',
  }),

  demandSubAccounts: makeQueryWithVars({
    queryFn: getDemandSubAccounts,
    queryKey: 'demandSubAccounts',
  }),

  expectedEarningsShares: makeQuery({
    queryFn: getExpectedEarningsShares,
    queryKey: 'expectedEarningsShares',
  }),

  expectedEarningsSharesBySubAccountUuid: makeQueryWithVars({
    queryFn: getExpectedEarningsSharesBySubAccountUuid,
    queryKey: 'expectedEarningsSharesBySubAccountUuid',
  }),
};
